// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-79e60c0b]:export{extraSmallBreakpoint:320px;smallBreakpoint:425px;mobileBreakpoint:768px;tabletBreakpoint:970px;desktopBreakpoint:1200px;largeBreakpoint:1400px;extraLargeBreakpoint:1600px}.add-to-cart-container .add-to-cart-form[data-v-79e60c0b]{display:initial}.add-to-cart-container .add-to-cart-form .add-cart-button[data-v-79e60c0b]{white-space:nowrap}\n", ""]);
// Exports
module.exports = exports;
